export default class FreebetsModel {
  constructor() {
    this._data = {
      add: 0,
      rest: 0,
      total: 0,
      win: 0,
      betValue: 0,
      isFreeBet: false,
      regularBetToRestore: 0,
      lastSpinWin: 0,
      status: '',
    }
  }

  get() {
    return this._data
  }

  set(value) {
    if (value.freebets) {
      this._data.isFreeBet  = true
      this._data.add = value.freebets.add
      this._data.rest = value.freebets.rest
      this._data.total = value.freebets.total
      this._data.win = value.freebets.win
      this._data.status = value.freebets.status
      this._data.betValue = value.freebets.betValue || value.freebets.bet
      if(value.win){
        this._data.lastSpinWin = value.win.total
      }
      else {
        this._data.lastSpinWin = 0
      }
    }
    else {

      this._data.add = 0
      this._data.rest = 0
      this._data.total = 0
      this._data.win = 0
      this._data.betValue = 0
      this._data.lastSpinWin = 0
      this._data.isFreeBet =  false
      this._data.status = ''
    }
  }

  set regularBetToRestore(value) {
    this._data.regularBetToRestore = value
  }
  get regularBetToRestore() {
    return this._data.regularBetToRestore
  }
}
